// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'
// import permission from './directive/permission'
// 多語言引用
import en from '@/assets/lang/en_US'
import zhCN from '@/assets/lang/zh_CN'
import zhTW from '@/assets/lang/zh_TW'

import App from './App'
import router from './router'
import store from './store'
import uuidv1 from 'uuid/v1'

import VueI18n from 'vue-i18n'
// permission control 验证token重定向登录页
import './permission'
// Vue.use(permission)

Vue.config.productionTip = false
// Element UI
Vue.use(ElementUI, {
  size: localStorage.getItem('layout-size') || 'medium' // set element-ui default size
})
// i18n
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'zh_TW',
  messages: {
    'zh_CN': zhCN,
    'zh_TW': zhTW,
    'en_US': en
  }
})
// 兼容element
locale.i18n((key, value) => i18n.t(key, value))

// 頁面引導introjs
import VueIntro from 'vue-introjs'
Vue.use(VueIntro);
import 'intro.js/introjs.css'

Vue.prototype.lyMsgSuccess = function (_that, res, form, flag) {
  if (res._token_uuid && form) {
    form._token_uuid = res._token_uuid;
  }
  this.$message({ showClose: true, message: res.msg, type: "success" });
  // 臨時錄入成功，并且有權限跳轉到授權頁面
  if (res.action == 2) {
    this.$router.push({ name: "system-auth", params: { perm: "reflash" } });
  } else {
    if (_that.list) {
      if (flag == 3) {
        _that.list(1);
      } else {
        // 顯示總頁
        if (_that.listTotal) {
          _that.listTotal = this.$t("PUB.total");
        }
        _that.list();
      }
    }
  }
}
Vue.prototype.lyMsgError = function (err, form, dur) {
  if (form && err._token_uuid) {
    form._token_uuid = err._token_uuid;
  }
  if (!dur && dur !== 0) {
    dur = 5000;
  }
  this.$message({ showClose: true, message: err.msg || err, type: "error", duration: dur });
}
Vue.prototype.lyMsgInfo = function (msg) {
  this.$message({ showClose: true, message: msg });
}
// 生成uuid函數
Vue.prototype.lyuuid = uuidv1;
// 重複提交的uuid
Vue.prototype.lyReSubmit = function (res, form) {
  if (form && res._token_uuid) {
    form._token_uuid = res._token_uuid;
  }
  //auto-focus the ref="inputFocus"
  this.$nextTick(() => {
    if (this.$refs.inputFocus) {
      this.$refs.inputFocus.focus();
    }
  });
}
// 異步授權釋放
Vue.prototype.lyAuthClose = function (_that) {
  if (_that.authAction) {
    _that.authAction = false;
  }
  if (_that.authId) {
    _that.authId = "";
  }
}
// 統一樣式更新
Vue.prototype.lyChgStyle = function () {
  return {
    "background-color": store.state.settings.theme || "#1682e6",
    color: "#FFF",
    "margin-bottom": "18px",
  };
}
// 統一樣式字體與顏色
Vue.prototype.lyChgFontStyle = function (fontSize, pot) {
  let cfs = {
    color: store.state.settings.theme || "#1682e6",
  };
  if (pot) {
    cfs['cursor'] = pot;
  }
  if (fontSize) {
    cfs["font-size"] = fontSize + "px";
  }
  return cfs;
}

Vue.prototype.Base64 = require('js-base64').Base64

import VueTouch from 'vue-touch';
Vue.use(VueTouch, { name: 'vue-touch' });

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

// 全局方法
import {
  lyParseTime, lyResetForm, lyResetFormErr, lyFormError, lyDownload, lyDelConfirm, lyColumnConvert, lyStartsWith,
  lySubstr, lyFormatNumber, lyEmptyObject, lySpecialCharSize, lyContainSensitive, lyNumberSize, lyAlphaCharSize,
  lyValidNumber, lyValidEmail, lyValidRequired, lyValidMin, lyValidMax, lyValidRange, lyChangeTheme, lyImgToBase64, lyChgHeaderWidth, lyExpTableView,
  lyConvertRGB2Hex, lyTransferFunc, lyMessage, lyValidAmountRequired, lyMapToList, lyBackgroundStyleLogo,
  lyTriangleLogo, lyFormStyle, lyChangeFileSize, lyValidString, lyHeaders, lyThemeColor
} from "@/utils/lyods";
Vue.prototype.lyParseTime = lyParseTime
Vue.prototype.lyResetForm = lyResetForm
Vue.prototype.lyResetFormErr = lyResetFormErr
Vue.prototype.lyFormError = lyFormError
Vue.prototype.lyDownload = lyDownload
Vue.prototype.lyDelConfirm = lyDelConfirm
Vue.prototype.lyColumnConvert = lyColumnConvert
Vue.prototype.lyStartsWith = lyStartsWith
Vue.prototype.lySubstr = lySubstr
Vue.prototype.lyFormatNumber = lyFormatNumber
Vue.prototype.lyEmptyObject = lyEmptyObject
Vue.prototype.lySpecialCharSize = lySpecialCharSize
Vue.prototype.lyContainSensitive = lyContainSensitive
Vue.prototype.lyNumberSize = lyNumberSize
Vue.prototype.lyAlphaCharSize = lyAlphaCharSize
Vue.prototype.lyValidNumber = lyValidNumber
Vue.prototype.lyValidEmail = lyValidEmail
Vue.prototype.lyValidRequired = lyValidRequired
Vue.prototype.lyValidMin = lyValidMin
Vue.prototype.lyValidMax = lyValidMax
Vue.prototype.lyValidRange = lyValidRange
Vue.prototype.lyChangeTheme = lyChangeTheme
Vue.prototype.lyImgToBase64 = lyImgToBase64
Vue.prototype.lyChgHeaderWidth = lyChgHeaderWidth
Vue.prototype.lyExpTableView = lyExpTableView
Vue.prototype.lyConvertRGB2Hex = lyConvertRGB2Hex
Vue.prototype.lyTransferFunc = lyTransferFunc
Vue.prototype.lyMessage = lyMessage
Vue.prototype.lyValidAmountRequired = lyValidAmountRequired
Vue.prototype.lyMapToList = lyMapToList
Vue.prototype.lyBackgroundStyleLogo = lyBackgroundStyleLogo
Vue.prototype.lyTriangleLogo = lyTriangleLogo
Vue.prototype.lyFormStyle = lyFormStyle
Vue.prototype.lyChangeFileSize = lyChangeFileSize
Vue.prototype.lyValidString = lyValidString
Vue.prototype.lyHeaders = lyHeaders
Vue.prototype.lyThemeColor = lyThemeColor

// 增加一個全局實圖屬性
var LY_VIEW_PANEL = [];
Vue.prototype.lyViewShowChg = function (_that, name) {
  let _ops = ["viewAddShow", "viewShareShow", "viewEditShow", "viewSearchShow"];
  // 之前窗口關閉
  for (let i in LY_VIEW_PANEL) {
    let _oth = LY_VIEW_PANEL[i];
    for (let j in _ops) {
      let _prop = _ops[j];
      _oth[_prop] = false;
    }
  }
  // 清空
  LY_VIEW_PANEL = [];
  // name為空
  if (name) {
    _that[name] = true;
  }
  if (_that) {
    LY_VIEW_PANEL.push(_that);
  }
}

/* eslint-disable no-new */
// 定义外部接口可配置
import axios from 'axios'
let startApp = function () {
  axios.get('/static/config.json').then((res) => {
    // 基础地址
    Vue.prototype.BASE_URL = res.data.BASE_URL;

    new Vue({
      el: '#app',
      router,
      store,
      i18n,
      template: '<App/>',
      components: { App }
    })
  })
}
// 啟動
startApp()



// WEBPACK FOOTER //
// ./src/main.js